export default __webpack_public_path__ + "static/media/bh.c0b4c5f6.svg";